import { ACCOUNT_VIDEO_REPORT_ID } from '../modules/campaigns-reports/config/reports/account-video/accountVideoReportId';
import { ACCOUNT_REPORT_ID } from '../modules/campaigns-reports/config/reports/account/accountReportId';
import { CAMPAIGN_REALTIME_REPORT_ID } from '../modules/campaigns-reports/config/reports/campaign-realtime/campaignRealtimeReportId';
import { CAMPAIGN_VIDEO_REPORT_ID } from '../modules/campaigns-reports/config/reports/campaign-video/campaignVideoReportId';
import { CAMPAIGN_REPORT_ID } from '../modules/campaigns-reports/config/reports/campaign/campaignReportId';
import { CAMPAIGNS_GROUPS_REALTIME_REPORT_ID } from '../modules/campaigns-reports/config/reports/campaigns-groups-realtime/campaignGroupRealtimeReportId';
import { CAMPAIGNS_GROUPS_REPORT_ID } from '../modules/campaigns-reports/config/reports/campaigns-groups/campaignGroupReportId';
import { CONVERSIONS_REPORT_ID } from '../modules/campaigns-reports/config/reports/conversions/conversionsReportId';
import { CREATIVE_LIBRARY_REPORT_ID } from '../modules/campaigns-reports/config/reports/creative-library/creativeLibraryReportId';
import { CREATIVE_REALTIME_REPORT_ID } from '../modules/campaigns-reports/config/reports/creative-realtime/creativeRealtimeReportId';
import { DCO_CAMPAIGN_CREATIVE_REPORT_ID } from '../modules/campaigns-reports/config/reports/creative-template-dco/dcoCampaignCreativeReportId';
import { CREATIVE_VIDEO_REPORT_ID } from '../modules/campaigns-reports/config/reports/creative-video/creativeVideoReportId';
import { CREATIVE_REPORT_ID } from '../modules/campaigns-reports/config/reports/creative/creativeReportId';
import { DYNAMIC_REPORTS_REPORT_ID } from '../modules/campaigns-reports/config/reports/dynamic-reports/dynamicReportsReportId';
import { FUNNELS_REPORT_ID } from '../modules/campaigns-reports/config/reports/funnels/funnelsReportId';
import { HIERARCHY_CAMPAIGN_REPORT_ID } from '../modules/campaigns-reports/config/reports/hierarchy-campaign/hierarchyCampaignReportId';
import { PERFORMANCE_RULES_REPORT_ID } from '../modules/campaigns-reports/config/reports/performance-rules/performanceRulesReportId';
import { SCHEDULED_REPORTS_REPORT_ID } from '../modules/campaigns-reports/config/reports/scheduled-reports/scheduledReportsReportId';

export const REPORT_DATA_MAP_VALUES = {
    CAMPAIGNS: 'campaigns',
    CAMPAIGNS_GROUPS: 'campaignsGroups',
    CREATIVES: 'creatives',
    ACCOUNTS: 'accounts',
    CONVERSIONS: 'conversions',
    FUNNELS: 'funnels',
    PERFORMANCE_RULES: 'performanceRules',
    SCHEDULED_REPORTS: 'scheduled-reports',
    DYNAMIC_REPORTS: 'dynamic-reports',
    CREATIVE_LIBRARY: 'creative-library',
};

export const REPORT_DATA_MAP_KEYS = {
    [CAMPAIGN_REPORT_ID]: REPORT_DATA_MAP_VALUES.CAMPAIGNS,
    [CAMPAIGN_REALTIME_REPORT_ID]: REPORT_DATA_MAP_VALUES.CAMPAIGNS,
    [CAMPAIGN_VIDEO_REPORT_ID]: REPORT_DATA_MAP_VALUES.CAMPAIGNS,
    [CAMPAIGNS_GROUPS_REPORT_ID]: REPORT_DATA_MAP_VALUES.CAMPAIGNS_GROUPS,
    [CAMPAIGNS_GROUPS_REALTIME_REPORT_ID]: REPORT_DATA_MAP_VALUES.CAMPAIGNS_GROUPS,
    [HIERARCHY_CAMPAIGN_REPORT_ID]: REPORT_DATA_MAP_VALUES.CAMPAIGNS,
    [CREATIVE_REPORT_ID]: REPORT_DATA_MAP_VALUES.CREATIVES,
    [CREATIVE_REALTIME_REPORT_ID]: REPORT_DATA_MAP_VALUES.CREATIVES,
    [DCO_CAMPAIGN_CREATIVE_REPORT_ID]: REPORT_DATA_MAP_VALUES.CREATIVES,
    [CREATIVE_VIDEO_REPORT_ID]: REPORT_DATA_MAP_VALUES.CREATIVES,
    [ACCOUNT_REPORT_ID]: REPORT_DATA_MAP_VALUES.ACCOUNTS,
    [ACCOUNT_VIDEO_REPORT_ID]: REPORT_DATA_MAP_VALUES.ACCOUNTS,
    [CONVERSIONS_REPORT_ID]: REPORT_DATA_MAP_VALUES.CONVERSIONS,
    [FUNNELS_REPORT_ID]: REPORT_DATA_MAP_VALUES.FUNNELS,
    [PERFORMANCE_RULES_REPORT_ID]: REPORT_DATA_MAP_VALUES.PERFORMANCE_RULES,
    [SCHEDULED_REPORTS_REPORT_ID]: REPORT_DATA_MAP_VALUES.SCHEDULED_REPORTS,
    [DYNAMIC_REPORTS_REPORT_ID]: REPORT_DATA_MAP_VALUES.DYNAMIC_REPORTS,
    [CREATIVE_LIBRARY_REPORT_ID]: REPORT_DATA_MAP_VALUES.CREATIVE_LIBRARY,
};
